import {
  CustomerDocument,
  CustomerDocumentsResponse,
  DocumentState,
} from "../entities/CustomerDocuments";

// API response structure for customer documents (GET /api/v1/documents/{businessKey})
export interface ApiCustomerDocumentsResponse {
  code: string;
  message: string;
  data: ApiCustomerDocument[];
}

export interface ApiCustomerDocument {
  id: string;
  documentType: string;
  documentName: string;
  fileName: string;
  version: string;
  uploadedAt: string;
  expirationDate: string | null;
  isReusable: boolean;
  isActive: boolean;
  kycStatus: string;
  ocrStatus: string;
  trustScore?: number | null;
  size?: number;
  contentType?: string;
}

export class CustomerDocumentsMapper {
  static toDomainModel(
    apiResponse: ApiCustomerDocumentsResponse
  ): CustomerDocumentsResponse {
    return {
      code: apiResponse.code,
      message: apiResponse.message,
      data: apiResponse.data.map((item) => this.toDomainItem(item)),
    };
  }

  static toDomainItem(apiItem: ApiCustomerDocument): CustomerDocument {
    return {
      id: apiItem.id,
      type: apiItem.documentType,
      name: apiItem.documentName,
      state: this.deriveState(
        apiItem.isActive,
        apiItem.expirationDate,
        apiItem.kycStatus,
        apiItem.ocrStatus
      ),
      expiration: apiItem.expirationDate ?? "-",
      reusable: apiItem.isReusable,
      relatedRequest: "-",
      kyc: apiItem.kycStatus === "OK",
      ocr: apiItem.ocrStatus === "OK",
      trust: apiItem.trustScore ?? null,
      version: apiItem.version,
    };
  }

  static toDomainItems(apiItems: ApiCustomerDocument[]): CustomerDocument[] {
    return apiItems.map((item) => this.toDomainItem(item));
  }

  /**
   * Derives DocumentState from API fields (isActive, expirationDate, kycStatus, ocrStatus).
   */
  private static deriveState(
    isActive: boolean,
    expirationDate: string | null,
    kycStatus: string,
    ocrStatus: string
  ): DocumentState {
    if (!isActive) return "INVALID";
    if (
      expirationDate &&
      new Date(expirationDate).getTime() < Date.now()
    ) {
      return "EXPIRED";
    }
    if (kycStatus !== "OK" || ocrStatus !== "OK") return "WARN";
    return "VALID";
  }
}
